import { useSWRConfig } from "swr";
import { ResponseError } from "superagent";
import { getUserToken } from "src/utils/jwtToken";
import { useActingAsOverrideHeader } from "../auth";
import { useTokenRefreshHandler } from "../hooks";
import { useUserService } from "../services";
import { errorHandler } from "src/hooks/errorHandler";

export interface ScheduleFollowUpRequest {
  eventId: number;
  contactIds?: number[]; // Optional - if not provided, will schedule follow-up for all guests with assigned templates
  delayHours: number;
}

export interface ScheduleFollowUpResponse {
  success: boolean;
  scheduledTime: string;
  guestCount: number;
}

export function useScheduleFollowUp() {
  const accessToken = getUserToken();
  const service = useUserService();
  const { mutate, cache } = useSWRConfig();
  const tokenRefreshHandler = useTokenRefreshHandler();
  const override = useActingAsOverrideHeader();

  const headers: { [index: string]: string } = {
    "JWT-TOKEN": accessToken as string,
  };

  if (override) {
    headers.override = override;
  }

  return async (
    request: ScheduleFollowUpRequest,
  ): Promise<ScheduleFollowUpResponse> => {
    try {
      const response = await service
        .post(`/api/webinars/${request.eventId}/follow-up/schedule`)
        .set(headers)
        .send({
          contactIds: request.contactIds,
          delayHours: request.delayHours,
        })
        .then(tokenRefreshHandler)
        .then((res: Response) => res.body);

      // Invalidate webinar queries to refresh the data
      // @ts-ignore
      const keys = cache.keys();
      Array.from(keys)
        .filter((r: any) => r.includes("/api/webinars"))
        .forEach((k: any) => {
          mutate(k);
        });

      return response;
    } catch (error) {
      throw errorHandler(error as ResponseError);
    }
  };
}

export default useScheduleFollowUp;
